import React, { FC } from 'react';
import { Field, Form, Formik, FieldProps, FormikHelpers } from 'formik';

import { PasswordRecoveryData } from 'types';
import { composeValidators, required, pattern, phoneRegexp } from 'utils/validate';
import { MAX_ATTEMPTS_CODE_REACHED } from 'constants/errors';
import { PatternFormat } from 'react-number-format';
import formStyles from 'pages/Login/components/LoginForm/LoginForm.module.scss';
import styles from './PasswordRecoveryForm.module.scss';

interface Props {
  onSubmit: (values: PasswordRecoveryData) => Promise<any>;
}

export const PasswordRecoveryForm: FC<Props> = ({ onSubmit }) => {
  const handleSubmit = async (values: PasswordRecoveryData, { setFieldError }: FormikHelpers<PasswordRecoveryData>) => {
    try {
      await onSubmit(values);
    } catch (e: any) {
      if (e?.data?.message === 'max_attempts_reached') {
        setFieldError('phone', MAX_ATTEMPTS_CODE_REACHED);
      } else {
        setFieldError('phone', 'Ошибка');
      }
    }
  };

  return (
    <Formik
      initialValues={{
        phone: '',
      }}
      validateOnMount
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, isValid }) => (
        <Form className={formStyles.form} noValidate>
          <p className={styles.description}>
            Введите номер телефона, указанный в вашем профиле. Мы отправим на него код из СМС.
          </p>
          <Field name="phone" validate={composeValidators([required(), pattern(phoneRegexp)])}>
            {({ field, meta, form }: FieldProps) => {
              const error = meta.touched && meta.error;
              return (
                <div className={formStyles.field}>
                  <label htmlFor="recovery-phone">Телефон<span className={formStyles.required}>*</span></label>
                  <PatternFormat
                    id="recovery-phone"
                    name={field.name}
                    value={field.value}
                    onBlur={field.onBlur}
                    onValueChange={({ value }) => form.setFieldValue(field.name, value)}
                    valueIsNumericString
                    format="+7 (###) ### ## ##"
                    allowEmptyFormatting
                    type="tel"
                    autoComplete="tel-national"
                    autoFocus
                    required
                    className={formStyles.input}
                    aria-invalid={!!error}
                    aria-describedby="recovery-phone-error"
                  />
                  <div id="recovery-phone-error" className={formStyles.error} aria-live="polite">{error || ' '}</div>
                </div>
              );
            }}
          </Field>
          <button className={formStyles.submitBtn} type="submit" disabled={!isValid || isSubmitting} aria-busy={isSubmitting}>
            {isSubmitting ? 'Отправляем…' : 'Отправить код по СМС'}
          </button>
        </Form>
      )}
    </Formik>
  );
};
